import React, { useState, useEffect } from "react";
import {
    getActiveModule,
} from "../../services/ActivePrograms";
import Loader from "../../commonComponent/Loader";
import ActiveModuleInfo from "./ActiveModuleInfo";
import ActiveModuleEdit from "./ActiveModuleEdit";
const ActiveModuleView = (props) => {

    const [moduleIndex, setModuleIndex] = useState(0);
    const [getModuleList, setGetModuleList] = useState([]);
    const [isLoading, setLoader] = useState(true);
    const [module, setModule] = useState(null);
    const [editMode, setEditMode] = useState(false);

    useEffect(() => {
        getModuleById(); 
       // eslint-disable-next-line 
    }, [props.programId]);


    const getModuleById = async () => {
        try {
            const response = await getActiveModule(props.programId);
            setLoader(false);
            if (response.status === 200) {
                let reversedArr = [...response?.data?.data]
                setGetModuleList(reversedArr);
                // setAttachmentList({});
                // setModuleContent('');
                // setDescription("");
                // setInputList([{ addPoints: "" }]);
                // setModuleName("");
                // setCoverShowImageCreate("");
                // setCoverShowImage("");
                // setExistList([]);
            } else {
                console.log(response?.data || response.message);
            }
        } catch (error) {
            // setLoader(false);
            setGetModuleList([]);
            error?.data?.data &&
                console.log(error?.data?.data || error.data?.message);
        }
    };

    const handleNextModule = (currentModule) => {

        const currentIndex = getModuleList.findIndex(m => m._id === currentModule._id);
        setModuleIndex(currentIndex + 1);
        if (currentIndex < getModuleList.length - 1) {
            setModule(getModuleList[currentIndex + 1]);
        }
    }

    const handlePreviousModule = (currentModule) => {
        const currentIndex = getModuleList.findIndex(m => m._id === currentModule._id);
        setModuleIndex(currentIndex - 1);
        if (currentIndex > 0) {
            setModule(getModuleList[currentIndex - 1]);
        }
    }
    const handleAllModule = () => {
        setModuleIndex(0);
        setModule(null);
    }
    const handleSetModule = (module) => {
        setModule(module);
        setModuleIndex(getModuleList.findIndex(m => m._id === module._id));
    }
    const handleEditModule = (module) => {
        setEditMode(true);
    }
   
    return (
        <div className="containerw">
            
            <div className="table_resouter mt-3">
                {isLoading ? (
                    <center>
                        <div
                            style={{ width: "3rem", height: "3rem", color: "#1f7e78" }}
                            className="spinner-border mt-3 mb-4"
                            role="status"
                        />
                    </center>
                ) : getModuleList.length === 0 ? (
                    <Loader textClassName={`mt-0`} showBR={false} emptyTextKey={`noData`} mainClassName={`active_n0data2`} />
                ) : (
                    <>
                        {module && editMode && <ActiveModuleEdit setEditMode={setEditMode} currentIndex={moduleIndex} moduleId={module._id} programId={props.programId} />}
                        {module && !editMode && <ActiveModuleInfo handleEditModule={handleEditModule} currentIndex={moduleIndex} hasNextModule={moduleIndex < getModuleList.length - 1} hasPreviousModule={moduleIndex > 0} handleAllModule={handleAllModule} handleNextModule={handleNextModule} handlePreviousModule={handlePreviousModule} module={module} programId={props.programId} />}

                        {!module && getModuleList?.map((curelem, index) => {

                        return (
                            <div className="d-flex mb-3" key={index}>
                                <span className="px-3 py-3 numbr">{index + 1 < 10 && "0"}{index + 1}</span>
                                <button className="flex-grow-1 card d-flex px-4 py-3 flex-row justify-content-between text-start" onClick={() => handleSetModule(curelem)}>
                                    <div className="d-flex">
                                        <img
                                            src={curelem.image}
                                            onError={(e) => {
                                                e.target.src = "images/defaultPlaceholder.jpg"
                                            }}
                                            alt=""
                                            className="member_listimage squre_image2"
                                        />
                                        <div className="ms-3">
                                            <h5 className="mb-1">{curelem.title}</h5>
                                            <p className="mb-0">{curelem.description}</p>
                                        </div>
                                    </div>
                                </button>
                            </div>
                        );
                        })}
                    </>
                )}
            </div>
        </div>
    );
};

export default ActiveModuleView;
